export default __webpack_public_path__ + "static/media/7.80465729.png";